import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { WhatIsSection } from './components/WhatIsSection';
import { IncludesSection } from './components/IncludesSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { NumbersSection } from './components/NumbersSection';
import { NotForEveryoneSection } from './components/NotForEveryoneSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { PurchaseSection } from './components/PurchaseSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingCTA } from './components/FloatingCTA';
import { CountdownBar } from './components/CountdownBar';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const pixelId = '26164957323164507';
    // Initialize fbq safely
    const w = window as any;
    if (!w.fbq) {
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Load the pixel script safely
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
    // Add noscript pixel image
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    document.body.appendChild(img);
  }, []);
  return <div className="min-h-screen bg-zinc-950 font-sans selection:bg-amber-500/30 selection:text-amber-200 overflow-x-hidden" data-id="element-0">
      <CountdownBar data-id="element-1" />
      <main className="pb-24 pt-10" data-id="element-2">
        {' '}
        {/* Padding bottom for floating CTA, padding top for countdown bar */}
        <HeroSection data-id="element-3" />
        <WhatIsSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <BeforeAfterSection data-id="element-7" />
        <NumbersSection data-id="element-8" />
        <NotForEveryoneSection data-id="element-9" />
        <IncludesSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <BonusSection data-id="element-12" />
        <PurchaseSection data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>

      <SocialProofPopup data-id="element-16" />
      <FloatingCTA data-id="element-17" />
    </div>;
}